import React from "react";
import Image from "../../assets/image/svg/confirm_pop_up.svg";
import Close from "../../assets/image/svg/close_icon.svg";
const FormConfirmPopUp = ({ para, setPopUp }) => {
  return (
    <>
      <div className=" position-fixed top-0 z-index vh-100 w-100 bg-black opacity-5"></div>
      <div className="position-fixed z-index top-0 vh-100 w-100 d-flex justify-content-center align-items-center">
        <div className="container position-relative bg-white rounded-3 text-center p-5">
          <img
            onClick={() => setPopUp(false)}
            width={25}
            className="position-absolute cursor_pointer end-0 top-0 mt-3 me-3"
            src={Close}
            alt="close"
          />
          <img src={Image} alt="confirm" />
          <p className="col-md-9 mx-auto mt-4 ff_inter fw-noraml fs_21 mb-0">
            {para}
          </p>
        </div>
      </div>
    </>
  );
};

export default FormConfirmPopUp;
